<template>
  <footer>
    <section>
      <div class="container">
        <div class="footer f f-col f-jbetween">
          <Logo v-bind:dark="false" v-bind:blue="true" size="s" />
          <SocialMediaIcons
            v-if="isMobile"
            class=""
            :icons="socialMedia"
            :iconsWidth="'24px'"
          />
        </div>
      </div>
    </section>
    <section>
      <div class="container d-f">
        <address
          v-for="(adress, index) in footerInformations"
          v-bind:key="index"
        >
          <span
            v-for="(line, index) in adress"
            v-bind:key="index"
            :class="line.class"
          >
            {{ line.text }}
          </span>
        </address>
        <div v-if="!isMobile" class="SocialMediaIconsWrapper">
          <SocialMediaIcons :icons="socialMedia" :iconsWidth="'24px'" />
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import SocialMediaIcons from "@/components/SocialMediaIcons";
import Logo from "@/components/svg/Logo";

export default {
  name: "Footer",
  components: {
    Logo,
    SocialMediaIcons,
  },
  props: {
    socialMedia: Object,
    footerInformations: Array,
  },
  mounted() {
    this.setIsMobile();
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/colors";
@import "../scss/utils";

footer {
  color: $blue;
  background: white;
  padding-bottom: 40px;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 30px;
}

@include mobile-s() {
  .container {
    flex-direction: column;
  }
}
.logo_wrapper {
  margin-left: -20px;
}

section {
  display: flex;
}

address {
  margin-top: 20px;

  .marginBottom {
    margin-bottom: 10px;
  }

  span {
    text-align: left;
    margin-bottom: 0;
    font-size: 12px;
    font-style: normal;
    display: inline-block;
    width: 100%;
  }

  @include desktop() {
    max-width: 25%;
  }
}

.SocialMediaIconsWrapper {
  flex-grow: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
</style>
